import classNames from "classnames";
import {
  STORE_OPTIONS,
  STATE_OPTIONS,
  getDistrictsByState,
  CUSTOMER_FORM_FIELDS,
  CUSTOMER_FORM_FIELDS_PAIRED,
} from "../../../Constant/AllFormFields";

/** Reusable text / email / numeric input */
const TextField = ({
  field,
  values,
  errors,
  handleFieldChange,
  handleFieldBlur,
}) => (
  <div className="field-wrap">
    <span className="field-label">{field.label}</span>
    <input
      id={field.id}
      className={classNames("field", field.mono && "field--mono", {
        invalid: !!errors[field.id],
      })}
      type={field.type}
      inputMode={field.inputMode}
      maxLength={field.maxLength}
      placeholder={field.placeholder}
      required={field.required}
      value={values[field.id]}
      onChange={(e) =>
        handleFieldChange(field.id, e.target.value, field.sanitize)
      }
      onBlur={() => handleFieldBlur(field.id)}
    />
    {errors[field.id] && <div className="err-msg">{errors[field.id]}</div>}
  </div>
);

/** Reusable select dropdown */
const SelectField = ({
  id,
  label,
  options,
  value,
  error,
  onChange,
  onBlur,
  placeholder,
  disabled,
}) => (
  <div className="field-wrap">
    <span className="field-label">{label}</span>
    <select
      id={id}
      className={classNames("field", { invalid: !!error })}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(id, e.target.value)}
      onBlur={() => onBlur && onBlur(id)}
    >
      {placeholder && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {options.map((opt) => (
        <option key={opt} value={opt}>
          {opt}
        </option>
      ))}
    </select>
    {error && <div className="err-msg">{error}</div>}
  </div>
);

const CustomerInfoSection = ({
  values,
  errors,
  handleFieldChange,
  handleFieldBlur,
}) => {
  // Districts are derived from the selected state — updates automatically
  const cityOptions = getDistrictsByState(values.state);

  return (
    <section className="card">
      <h2 className="card__title">
        <span className="section-icon">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14c-4.4 0-8 2-8 4.5V21h16v-2.5c0-2.5-3.6-4.5-8-4.5z"
            />
          </svg>
        </span>
        Customer Information
      </h2>

      <div className="grid-2">
        {/* Store Name */}
        <SelectField
          id="storeName"
          label="Store Name"
          options={STORE_OPTIONS}
          value={values.storeName}
          error={errors.storeName}
          onChange={handleFieldChange}
          onBlur={handleFieldBlur}
        />

        {/* Customer Name, Mobile, Email */}
        {CUSTOMER_FORM_FIELDS.map((field) => (
          <TextField
            key={field.id}
            field={field}
            values={values}
            errors={errors}
            handleFieldChange={handleFieldChange}
            handleFieldBlur={handleFieldBlur}
          />
        ))}

        {/* State — pick first, city unlocks after */}
        <SelectField
          id="state"
          label="State"
          options={STATE_OPTIONS}
          value={values.state}
          error={errors.state}
          placeholder="Select state"
          onChange={handleFieldChange}
          onBlur={handleFieldBlur}
        />

        {/* City — locked until a state is chosen */}
        <SelectField
          id="city"
          label="City / District"
          options={cityOptions}
          value={values.city}
          error={errors.city}
          placeholder={
            values.state ? "Select city / district" : "Select state first"
          }
          disabled={!values.state}
          onChange={handleFieldChange}
          onBlur={handleFieldBlur}
        />

        {/* Pin Code */}
        <div className="grid-2 grid-2--nested">
          {CUSTOMER_FORM_FIELDS_PAIRED.map((field) => (
            <TextField
              key={field.id}
              field={field}
              values={values}
              errors={errors}
              handleFieldChange={handleFieldChange}
              handleFieldBlur={handleFieldBlur}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CustomerInfoSection;
